import { render } from "./WhyArea.vue?vue&type=template&id=1dd3bf72"
import script from "./WhyArea.vue?vue&type=script&lang=js"
export * from "./WhyArea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__